export default __webpack_public_path__ + "static/media/screenShots_blash-3.a82eb706.jpg";